"use client";

import { BaseModal } from "@/components/ui/modal";
import { useWelcomeModal } from "../hooks/useWelcomeModal";
import { WelcomeModalContent } from "./WelcomeModalContent";

export function WelcomeModal() {
  const { isOpen, close } = useWelcomeModal();

  return (
    <BaseModal isOpen={isOpen} onClose={close}>
      <WelcomeModalContent onClose={close} />
    </BaseModal>
  );
}
